import { useRef } from "react"
import { Button } from "flowbite-react"

import { useRegistrosContext } from "@/contexts/registros.context"
import CustomTextInput from "@/components/basic/input-text/input-text.component"
import CustomSelect from "@/components/basic/select/select.component"

const RegistrosFilterForm = () => {
  const { formik, isLoadingRegistros } = useRegistrosContext()

  const formRef = useRef<HTMLFormElement>(null)
  const handleClearForm = () => {
    formik.resetForm({
      values: {
        dataInicio: new Date(new Date().setMonth(new Date().getMonth() - 1))
          .toISOString()
          .split('T')[0],
        dataFim: new Date().toISOString().split('T')[0],
        situacoes: 'todos',
      }
    })
    formik.submitForm()
    formRef.current?.reset()
  }

  function getInicioMinDate() {
    const fim = new Date(formik.values.dataFim)
    if (fim.toString() === 'Invalid Date')
      return new Date(new Date().setMonth(new Date().getMonth() - 2))
        .toISOString()
        .split('T')[0]
    fim.setDate(fim.getDate() - 90)
    return fim.toISOString().split('T')[0]
  }

  function getFimMaxDate() {
    const inicio = new Date(formik.values.dataInicio)
    if (inicio.toString() === 'Invalid Date')
      return new Date(new Date().setMonth(new Date().getMonth() + 1))
        .toISOString()
        .split('T')[0]
    inicio.setDate(inicio.getDate() + 90)
    return inicio.toISOString().split('T')[0]
  }

  return (
    <form
      ref={formRef}
      onSubmit={formik.handleSubmit}
      className='flex flex-col md:grid grid-cols-12 w-full p-3 bg-white gap-5 mb-5 rounded-lg'
    >
      <div className='col-span-4'>
        <CustomTextInput
          type='date'
          field='dataInicio'
          formik={formik}
          defaultValue={formik.values.dataInicio}
          min={getInicioMinDate()}
          max={formik.values.dataFim}
          label='Importado de:'
        />
      </div>
      <div className='col-span-4'>
        <CustomTextInput
          type='date'
          field='dataFim'
          formik={formik}
          defaultValue={formik.values.dataFim}
          min={formik.values.dataInicio}
          max={getFimMaxDate()}
          label='Até:'
        />
      </div>
      <div className='col-span-4'>
        <CustomSelect
          data-testid='situacao-select'
          options={[
            {
              label: 'Todos',
              value: 'todos'
            },
            {
              label: 'Pendente',
              value: '0'
            },
            {
              label: 'Em processamento',
              value: '1'
            },
            {
              label: 'Com erro',
              value: '2'
            },
            {
              label: 'Com sucesso',
              value: '3'
            },

          ]}
          field='situacoes'
          formik={formik}
          label='Situação:'
        />
      </div>
      <div className='col-span-4 col-start-9 flex justify-end items-end'>
        <div className='flex'>
          <Button
            color='ghost'
            size={'sm'}
            className='text-xs'
            onClick={handleClearForm}
          >
            Limpar
          </Button>
          <Button
            className='bg-quaternary ml-2'
            type='submit'
            size={'sm'}
            disabled={isLoadingRegistros}
            isProcessing={isLoadingRegistros}
          >
            Filtrar
          </Button>
        </div>
      </div>
    </form>
  )
}
export default RegistrosFilterForm
